var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM4 20C4 18.78 4.16 17.58 4.42 16.44L13.98 26V28C13.98 30.2 15.78 32 17.98 32V35.86C10.12 34.86 4 28.14 4 20ZM27.98 28C29.78 28 31.26 29.18 31.78 30.8C34.38 27.96 36 24.16 36 20C36 13.3 31.84 7.54 25.98 5.18V6C25.98 8.2 24.18 10 21.98 10H17.98V14C17.98 15.1 17.08 16 15.98 16H11.98V20H23.98C25.08 20 25.98 20.9 25.98 22V28H27.98Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial24Px);
export default __webpack_public_path__ + "static/media/social_24px.5e916c647ec5fc9397313f810763ab62.svg";
export { ForwardRef as ReactComponent };